// extracted by mini-css-extract-plugin
export default {"keyboard":"CounterCash_keyboard__S5ih-","input":"CounterCash_input__YlLA3","widthBox":"CounterCash_widthBox__2HU3Q","marginTop":"CounterCash_marginTop__+Wn2E"};